import axios from "@/libs/api.request";

// 获取预约派送列表
export const getAppointmentPieces = params => {
  return axios.request({
    url: "/statistics/getReserve",
    method: "get",
    params
  });
};
